import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step5 } from '../../../../shared/models/component-messages/diveAT/step5';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { LotMarche } from '../models/LotMarche';

@Component({
  selector: 'app-lot-marche',
  templateUrl: './lot-marche.component.html'
})
export class LotMarcheComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() lotMarche: LotMarche;
  @Input() index = 0;

  public step5 = new Step5();

  public radioButtonValue: string;
  public attribue = RadioCheckBoxEnum.attribue;
  public infructueux = RadioCheckBoxEnum.infructueux;
  public sansSuite = RadioCheckBoxEnum.sansSuite;

  constructor() { }

  public ngOnInit() {
    if (this.lotMarche?.resultat?.infructueux === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.infructueux;
    } else if (this.lotMarche?.resultat?.sansSuite === RadioCheckBoxEnum.emptyValue) {
      this.radioButtonValue = this.sansSuite;
    } else {
      this.radioButtonValue = this.attribue;
    }
  }

  getUid() {
    return this.uid + '_SepSep_LotMarche';
  }

  getResultatAttribution() {
    return this.parentForm.controls[this.getUid() + '_SepSep_TypeResultatAttribution_SepAtt_attribue']?.value;
  }
}
